import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

// Admin-authored Mains questions (question + model answer) served to the app as "Today's Question".
// Separate resource from mains submissions (mains.service.js).
const base = '/admin/mains/questions';

export const mainsQuestionsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
};

export default mainsQuestionsService;
